import React from 'react'
import {
    AppBar,
    Toolbar,
    Typography
} from '@material-ui/core'


const CustomAppBar = ({ leftButton, title, rightButton }) => {
    return (
        <AppBar color="transparent" position="sticky" style={{ boxShadow: 'none' }}>
            <Toolbar style={{ justifyContent: 'space-between', paddingLeft: 0, minHeight: 75 }}>
                {leftButton}
                <Typography variant="h5">
                    {title}
                </Typography>
                {rightButton}
            </Toolbar>
        </AppBar>
    )
}

export default CustomAppBar